/* src/sb-modules/Frontend-Inline-SVG-Module/inline-svg.component.scss */
/*# sourceMappingURL=inline-svg.component.css.map */
